<template>
    <DModal
        :title="$t('common.delete_confirm_title')"
        :show="showModal"
        is-confirm
        is-error
        @close="$emit('close-delete-modal')"
        @confirm="$emit('delete-confirmed')"
    >
        <div
            v-if="showModal"
            class="m-3"
        >
            {{ $t('settings_certificate_providers.delete_confirm_message') }}
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'CertificateProviderDeleteModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-delete-modal', 'delete-confirmed']
}
</script>
